import { z } from '../zod.js';
import {
  CursorPaginationValidationBaseSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';
import { SUBMISSION_STATUSES, SubmissionStatusValidationEnum } from './enum';
import { CHARGE_ORDER_STATUS, ChargeOrderStatusValidationEnum } from '../charge/enum';

export const SubmissionListQueryValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend({
    search: z.string().optional().meta({
      description:
        "Search by `customerEmail`, `customerName`, and `formTitle`. Contains match (for example, 'jane' matches 'jane@example.com' and 'Jane Smith', while 'lead' matches 'Lead Capture Form').",
    }),
    pageId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter by the form page ID that received the submission.',
    }),
    customerId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter by the associated customer ID.',
    }),
    status: SubmissionStatusValidationEnum.optional().meta({
      description: `Filter by submission status. Valid values: ${Object.values(SUBMISSION_STATUSES).join(', ')}.`,
    }),
    orderStatus: ChargeOrderStatusValidationEnum.optional().meta({
      description: `Filter by lifecycle status. Valid values: ${CHARGE_ORDER_STATUS.join(', ')}. Without this filter, canceled submissions are included, as in the payments and bookings lists.`,
    }),
    createdAfter: z.iso.datetime().optional().meta({
      description:
        'Filter by lower bound of createdAt. Use a UTC ISO 8601 timestamp with a `Z` suffix.',
    }),
    createdBefore: z.iso.datetime().optional().meta({
      description:
        'Filter by upper bound of createdAt. Use a UTC ISO 8601 timestamp with a `Z` suffix.',
    }),
    livemode: LivemodeFilterValidationSchema,
  }).refine(
    data =>
      !(
        data.createdAfter &&
        data.createdBefore &&
        Date.parse(data.createdAfter) > Date.parse(data.createdBefore)
      ),
    {
      message: 'createdAfter must be earlier than or equal to createdBefore',
      path: ['createdBefore'],
    },
  ),
);
